import React from 'react';
import loaderImg from "../../images/logo/loaderlogo.png";
import './index.css';
const Loader = ({title}) => {
    return (
        <section className="container d-flex justify-content-center align-items-center flex-column" style={{ height: '100vh' }}>
            <img src={loaderImg} alt="loading" width={200}/>
        <section className='section-loader'><div className='my-loader'></div></section> </section>
           
    );
};

export default Loader;